const CANCELLATION_MESSAGE_PATTERNS = [
  'cancel rendering route',
  'abort fetching component for route',
  'route cancelled',
  'loading chunk',
  'hard navigate',
]

type ErrorWithCancellationFlag = {
  cancelled?: unknown
  message?: unknown
}

function getErrorMessage(error: unknown): string {
  if (typeof error === 'string') {
    return error
  }

  if (error && typeof error === 'object' && 'message' in error) {
    const message = (error as ErrorWithCancellationFlag).message
    if (typeof message === 'string') {
      return message
    }
  }

  return ''
}

export function isNavigationCancellationError(error: unknown): boolean {
  if (
    error &&
    typeof error === 'object' &&
    'cancelled' in error &&
    (error as ErrorWithCancellationFlag).cancelled === true
  ) {
    return true
  }

  const message = getErrorMessage(error).toLowerCase()
  if (!message) {
    return false
  }

  return CANCELLATION_MESSAGE_PATTERNS.some((pattern) => message.includes(pattern))
}
